import React,{useEffect} from 'react';
import './OurTeam.css';
import IconAE from '../assets/icons/IconAE.webp';


const teamLead=[
  {
    name:'Ayfer Evmez',
    role:'Pflegewissenschaftlerin M. Sc. / Geschäftsführung & Pflegedienstleitung',
    bio:'Pflegeexpertin mit Herz, Verstand und langjähriger Erfahrung in Leitung, Lehre und Praxis. Steht für Qualität, Empathie und Teamgeist in der Pflege.',
    focus:'Qualifikationen: Pflegeberaterin, Palliativ Fachkraft, Wundexpertin, Qualitätsmanagerin, Praxisanleiterin, Hygienebeauftragte, Dozentin für Pflegeberufe.',
    image:IconAE,
    initials:'AE',
    accent:'#41dfd1'
  },
  {
    name:'Sarah Schopp',
    role:'Pflegedienstleitung & Palliativfachkraft',
    bio:'Koordiniert die tägliche Versorgung unserer Kundinnen und Kunden und ist feste Ansprechpartnerin für Angehörige. Als Palliativfachkraft begleitet sie Menschen auch in ihrer letzten Lebensphase mit Ruhe und Würde.',
    focus:'Qualifikationen: Pflegedienstleitung, Palliativfachkraft.',
    initials:'SS',
    accent:'#2cb67d'
  }
];


const handlePointerMove=(event)=>{
  const card=event.currentTarget;
  if(window.matchMedia('(pointer: coarse)').matches)return;

  const rect=card.getBoundingClientRect();
  const x=((event.clientX-rect.left)/rect.width)*100;
  const y=((event.clientY-rect.top)/rect.height)*100;

  if(card._raf)cancelAnimationFrame(card._raf);
  card._raf=requestAnimationFrame(()=>{
    card.style.setProperty('--pointer-x',`${x}%`);
    card.style.setProperty('--pointer-y',`${y}%`);
  });
};

const resetPointer=(event)=>{
  const card=event.currentTarget;
  card.style.removeProperty('--pointer-x');
  card.style.removeProperty('--pointer-y');
};

const OurTeam=()=>{
  useEffect(()=>{
    const cards=document.querySelectorAll('.team-card');

    if(!cards.length)return;

    if(!('IntersectionObserver' in window)){
      cards.forEach((card)=>card.classList.add('is-visible'));
      return undefined;
    }

    const observer=new IntersectionObserver(
      (entries)=>{
        entries.forEach((entry)=>{
          if(entry.isIntersecting){
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {root:null,threshold:0.28}
    );

    cards.forEach((card,index)=>{
      card.style.setProperty('--card-delay',`${index*90}ms`);
      observer.observe(card);
    });

    return()=>observer.disconnect();
  },[]);

  return(
    <section className="our-team" id="unser-team">
      <div className="our-team__inner">
        <div className="our-team__headline">
          <span className="eyebrow">Menschen, die Cura Care prägen</span>
          <h2>Unser Team</h2>
          <p>
            Wir sind ein interdisziplinäres Pflege-Team, das moderne Standards lebt und
            Menschlichkeit in den Mittelpunkt stellt.
          </p>
        </div>

        <div className="our-team__lead">
          {teamLead.map((lead,index)=>(
            <article
              key={lead.name}
              className="team-card team-card--lead"
              style={{'--accent':lead.accent}}
              onMouseMove={handlePointerMove}
              onMouseLeave={resetPointer}
              aria-labelledby={`team-lead-${index}-name`}
            >
              <div className="team-card__glow" aria-hidden="true" />
              <div className="team-card__media">
                {lead.image?(
                  <img src={lead.image} alt={lead.name} loading="lazy" />
                ):(
                  <span aria-hidden="true">{lead.initials}</span>
                )}
              </div>
              <div className="team-card__content">
                <h3 id={`team-lead-${index}-name`}>{lead.name}</h3>
                <p className="team-card__role">{lead.role}</p>
                {lead.bio && <p>{lead.bio}</p>}
                {lead.focus && <p className="team-card__focus">{lead.focus}</p>}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
